export default __webpack_public_path__ + "static/blob1-e2b5050edd3ef6e0df47b40629d9caba.svg";